import React, { Component } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { getUserRole } from '../../../../services/common/util';
import CreateFamily from './createFamily';
import FamilyBreadcrumb from './familyBreadcrumb';

class FamilySearchMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div>
                <FamilyBreadcrumb />
                <div className="row" style={{ padding: '12px' }}>
                    <div className="col-md-3">
                        <TextField
                            label="Current Grid Search"
                            variant="outlined"
                            id="reset-form"
                            InputLabelProps={{
                                shrink: true
                            }}
                            type="string"
                            margin="dense"
                            onChange={this.props.onFilterTextChange}
                        />
                    </div>
                    <div className="col-md-2">
                        <FormControl variant="outlined" style={{ minWidth: 120, marginTop: '8px' }}>
                            <InputLabel id="page-size-label">Page Size</InputLabel>
                            <Select
                                labelId="page-size-label"
                                id="page-size"
                                value={this.props.pageSize}
                                onChange={this.props.onPageSizeChanged}
                                label="Page Size"
                            >
                                <MenuItem value={20}>20</MenuItem>
                                <MenuItem value={50}>50</MenuItem>
                                <MenuItem value={100}>100</MenuItem>
                                <MenuItem value={500}>500</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div className="col-md-2">
                        <button className="btn btn-primary button-info-grid" onClick={() => this.props.clearFilter()}>
                            <i className="fa fa-times" aria-hidden="true"></i> Clear Filter
                        </button>
                    </div>
                    <div className="col-md-5" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <div>
                            {/^superadmin|^admin|^labtech|facilityadmin/.test(getUserRole().toLowerCase()) && (
                                <CreateFamily context={this.props.context} />
                            )}
                        </div>
                        <div>
                            <button
                                className="btn btn-primary button-info-grid"
                                onClick={() => this.props.onBtnExport()}
                            >
                                <i className="fa fa-file-excel-o" aria-hidden="true"></i> Export
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FamilySearchMenu;
